// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-popover.picker-popover,
.ant-popover.color-picker-popover {
  width: auto;
}
.ant-popover.picker-popover .ant-popover-inner-content,
.ant-popover.color-picker-popover .ant-popover-inner-content {
  background-color: #eee;
}
.ant-popover.color-picker-popover .ant-popover-inner {
  margin-left: 0;
  margin-bottom: 0;
  border-radius: 12px;
}
.ant-popover.color-picker-popover .ant-popover-inner-content {
  padding: 20px;
  border-radius: 12px;
}
.font-btn-container {
  position: absolute;
  z-index: 15;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.font-btn-container button {
  border-radius: 8px;
  margin-right: 4px;
  margin-left: 4px;
  height: 28px;
  padding-top: 2px;
}
.font-btn-container button:focus {
  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
}
.font-btn-container .casual-btn {
  font-family: 'Poppins', apple color emoji, segoe ui emoji, noto color emoji, android emoji, sans-serif;
  font-weight: 600;
}
.font-btn-container .formal-btn {
  font-family: 'Lora', apple color emoji, segoe ui emoji, noto color emoji, android emoji;
  font-weight: 500;
}
.font-btn-container .playful-btn {
  font-family: 'Pattaya', apple color emoji, segoe ui emoji, noto color emoji, android emoji;
}
.font-btn-container .strong-btn {
  font-weight: 600;
  font-family: 'Oswald', apple color emoji, segoe ui emoji, noto color emoji, android emoji, sans-serif;
}
.font-btn-container .personal-btn {
  font-family: 'Gochi Hand', apple color emoji, segoe ui emoji, noto color emoji, android emoji;
}
.save-ecard-btn:focus {
  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
}
.select-ecard {
  border-radius: 6px;
  max-width: 100%;
  max-height: 100%;
  margin-left: auto;
  margin-right: auto;
  display: block;
}
.select-ecard-upload {
  height: 100%;
  min-width: 100%;
  border-radius: 6px;
  border: 1px dashed gray;
  padding: 24px;
  display: flex;
}
.ecard-preview {
  max-width: 100%;
}
.primary-background:disabled {
  background: #f5f5f5 !important;
}
.back-btn:focus {
  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
}
.bottom-btn-container {
  text-align: left;
  max-width: 575px;
  margin-top: -24px;
}
.bottom-btn-container .more-container {
  margin-right: 6px;
}
.bottom-btn-container .more-picker {
  padding: 6px;
  margin-right: 6px;
}
.bottom-btn-container .more-picker:focus {
  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
}
.bottom-btn-container .image-upload {
  padding: 6px;
}
.bottom-btn-container .image-upload svg {
  height: 18px;
  width: 18px;
}
.bottom-btn-container .image-upload:focus {
  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
}
.ecard-drawer {
  opacity: 0;
  max-width: 575px;
  width: 100%;
  margin-right: auto;
  height: calc(575px - 61px);
  bottom: -575px;
  position: absolute;
  background-color: white;
  transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1);
  overflow: auto;
  visibility: hidden;
}
.ecard-drawer.open {
  opacity: 1;
  bottom: -14px;
  transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1);
  z-index: 15;
  min-height: auto;
  visibility: visible;
}
.ecard-drawer .title-row {
  margin-left: 12px;
  margin-right: 12px;
  padding-top: 9px;
  margin-bottom: 8px;
}
.ecard-drawer .ecard-list {
  padding-left: 12px;
  padding-right: 12px;
  justify-content: left;
  overflow: auto;
  margin-left: 6px;
  padding-bottom: 55px;
  width: 100%;
}
.upload-drawer {
  opacity: 0;
  max-width: 575px;
  width: 100%;
  margin-right: auto;
  height: calc(575px - 65px);
  bottom: -700px;
  position: absolute;
  background-color: white;
  padding: 16px;
  z-index: 16;
  transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1);
  visibility: hidden;
}
.upload-drawer.hidden {
  display: none;
}
.upload-drawer.open {
  opacity: 1;
  bottom: -14px;
  transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1);
  z-index: 15;
  min-height: auto;
  visibility: visible;
  display: block;
}
.upload-content {
  height: 435px;
  border-radius: 16px;
  border: 1px #dfdfdf dashed;
  background-color: #f5f5f5;
  width: 100%;
}
.upload-icon {
  width: 100%;
  height: 100%;
  color: #3f8cff;
}
.image-icon {
  width: 18px;
  height: 18px;
}
.upload-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: center;
}
.upload-container .upload-icon-container {
  width: 90px;
  height: 90px;
  margin-left: auto;
  margin-right: auto;
}
.upload-container .upload-icon {
  width: 100%;
  height: 100%;
}
.upload-container .upload-text-container {
  width: 200px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
.upload-container .upload-text-container .fake-link {
  text-decoration: underline;
  color: #3f8cff;
  cursor: pointer;
}
.upload-container .upload-text-container .parameter-text {
  font-size: 10px;
  color: #555555;
}
.ant-popover-arrow {
  display: none;
}
.text-tools-container {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  padding-left: 12px;
}
.background-toggle-btn {
  padding: 4px;
  display: flex;
  font-size: 18px;
}
.background-toggle-btn:focus {
  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
}
.background-toggle-btn.btn-selected {
  background-color: #ccc;
}
.foreground-toggle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 40px;
}
.switch-container {
  display: flex;
  align-items: center;
}
.ecard-message-container {
  position: absolute;
  width: 100%;
  top: 0;
  max-height: 455px;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  padding: 20px;
  justify-content: center;
  align-items: center;
  left: 0;
}
.ecard-message-container .ecard-text {
  border: none;
  background-color: transparent;
  text-align: center;
  font-size: 26px;
  min-width: 50%;
  max-width: 75%;
  resize: none;
  border-radius: 8px;
  padding: 12px;
  font-family: 'Poppins', apple color emoji, segoe ui emoji, noto color emoji, android emoji, sans-serif;
  font-weight: 600;
}
.ecard-actions {
  bottom: 32px;
  position: absolute;
  left: 14px;
  width: calc(100% - 14px);
}
.ecard-actions .edit-text-btn {
  padding: 6px;
  right: 12px;
}
.ecard-actions .edit-text-btn:focus {
  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
}
.ecard-actions .edit-text-btn svg {
  width: 100%;
  height: 100%;
}
.ecard-actions .edit-text-complete {
  right: 0;
}
.render-image {
  width: 100% !important;
  max-height: 455px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
}
.render-image img {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: block;
  object-fit: cover;
  object-position: 50% 50%;
}
.ant-btn.large-circle {
  height: 40px;
  width: 40px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.text-right {
  text-align: right;
}
.ecard-title-text {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ecard-title-text .bold-header {
  margin-bottom: 0;
}
.color-picker-btn .ant-popover.picker-popover,
.color-picker-btn .ant-popover.color-picker-popover {
  width: auto;
}
.color-picker-btn .ant-popover.picker-popover .ant-popover-inner-content,
.color-picker-btn .ant-popover.color-picker-popover .ant-popover-inner-content {
  background-color: #eee;
}
.color-picker-btn .ant-popover.color-picker-popover .ant-popover-inner {
  margin-left: 0;
  margin-bottom: 0;
  border-radius: 12px;
}
.color-picker-btn .ant-popover.color-picker-popover .ant-popover-inner-content {
  padding: 20px;
  border-radius: 12px;
}
.color-picker-btn:focus {
  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
}
.title-row {
  margin-bottom: 12px;
}
.ecard-image-preview {
  margin: 6px;
  max-height: 75px;
}
.uppercase {
  text-transform: uppercase;
}
.ant-avatar.behavior-image {
  margin-right: 12px;
}
.circle-picker {
  background-color: #eee;
}
.emoji-container {
  width: 280px;
  height: 320px;
}
.bold-header {
  font-weight: 700;
}
.required {
  width: 8px;
  height: 8px;
  background-color: red;
  border-radius: 50%;
  display: block;
  z-index: 4;
  right: 4px;
  position: absolute;
}
.ant-popover aside.emoji-picker-react {
  padding: 8px;
  box-shadow: none;
}
.ant-popover aside.emoji-picker-react .emoji-categories {
  bottom: 4px;
  left: 0;
  position: absolute;
  width: 100%;
  background: #fff;
  border-radius: 30px;
  box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
  z-index: 101;
}
.ant-popover aside.emoji-picker-react .content-wrapper {
  bottom: 40px;
}
.ant-popover aside.emoji-picker-react .content-wrapper:before {
  content: '';
}
.ant-popover aside.emoji-picker-react .content-wrapper .emoji-group:before {
  text-transform: capitalize;
  font-size: 12px;
}
.ant-popover aside.emoji-picker-react .emoji-scroll-wrapper {
  top: 40px;
  padding-bottom: 40px;
}
.ant-popover aside.emoji-picker-react .skin-tones-list {
  margin-top: 14px;
}
.ant-popover aside.emoji-picker-react input.emoji-search {
  margin-top: 12px;
  border-radius: 8px;
  background-color: #f5f5f5;
  border: none;
}
.delete-modal .title-container {
  display: flex;
}
.delete-modal .title-container .icon-flex {
  flex: 2;
}
.delete-modal .title-container .title-text {
  flex: 8;
  font-weight: bold;
}
.delete-modal .title-container .icon-circle {
  background-color: #de1c1b;
  width: 56px;
  height: 56px;
  border-radius: 30px;
  padding: 16px;
}
.delete-modal .ant-modal-content {
  height: auto;
}
.delete-modal .ant-modal-content .ant-modal-body {
  padding: 12px;
}
.delete-modal .ant-btn-dangerous.ant-btn-primary {
  background: #de1c1b;
  border-color: #de1c1b;
}
.delete-modal .ant-btn-dangerous.ant-btn-primary:hover,
.delete-modal .ant-btn-dangerous.ant-btn-primary:active,
.delete-modal .ant-btn-dangerous.ant-btn-primary:focus {
  background: #de1c1b;
  border-color: #de1c1b;
}
.delete-modal .ant-btn:focus {
  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;
}
.delete-modal .delete-content {
  margin-left: 71px;
  margin-top: -24px;
}
@media only screen and (max-device-width: 420px) {
  .select-ecard-upload {
    padding: 18px;
  }
  .font-btn-container button {
    font-size: 9px;
    padding-left: 12px;
    padding-right: 12px;
  }
  .edit-text-complete {
    margin-left: 12px;
  }
  .edit-text-btn {
    right: 30px;
  }
  .text-tools-container {
    margin-left: 16px;
  }
  .text-tools-container .double-btn-container {
    margin-right: 12px;
  }
  .text-tools-container button {
    z-index: 25;
  }
  .ecard-image-preview {
    min-width: 75px;
    min-height: 75px;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nackle/ecard-editor/dist/editor.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;AACb;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,wDAAwD;EACxD,gDAAgD;AAClD;AACA;EACE,sGAAsG;EACtG,gBAAgB;AAClB;AACA;EACE,uFAAuF;EACvF,gBAAgB;AAClB;AACA;EACE,0FAA0F;AAC5F;AACA;EACE,gBAAgB;EAChB,qGAAqG;AACvG;AACA;EACE,6FAA6F;AAC/F;AACA;EACE,wDAAwD;EACxD,gDAAgD;AAClD;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wDAAwD;EACxD,gDAAgD;AAClD;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,wDAAwD;EACxD,gDAAgD;AAClD;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,wDAAwD;EACxD,gDAAgD;AAClD;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,sDAAsD;EACtD,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,aAAa;EACb,sDAAsD;EACtD,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,sDAAsD;EACtD,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,aAAa;EACb,sDAAsD;EACtD,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;AACA;EACE,wDAAwD;EACxD,gDAAgD;AAClD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;AACT;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sGAAsG;EACtG,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,wDAAwD;EACxD,gDAAgD;AAClD;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,QAAQ;AACV;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,wDAAwD;EACxD,gDAAgD;AAClD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mHAAmH;EACnH,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,OAAO;AACT;AACA;EACE,OAAO;EACP,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;;EAGE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,wDAAwD;EACxD,gDAAgD;AAClD;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".ant-popover.picker-popover,\n.ant-popover.color-picker-popover {\n  width: auto;\n}\n.ant-popover.picker-popover .ant-popover-inner-content,\n.ant-popover.color-picker-popover .ant-popover-inner-content {\n  background-color: #eee;\n}\n.ant-popover.color-picker-popover .ant-popover-inner {\n  margin-left: 0;\n  margin-bottom: 0;\n  border-radius: 12px;\n}\n.ant-popover.color-picker-popover .ant-popover-inner-content {\n  padding: 20px;\n  border-radius: 12px;\n}\n.font-btn-container {\n  position: absolute;\n  z-index: 15;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 30px;\n}\n.font-btn-container button {\n  border-radius: 8px;\n  margin-right: 4px;\n  margin-left: 4px;\n  height: 28px;\n  padding-top: 2px;\n}\n.font-btn-container button:focus {\n  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n}\n.font-btn-container .casual-btn {\n  font-family: 'Poppins', apple color emoji, segoe ui emoji, noto color emoji, android emoji, sans-serif;\n  font-weight: 600;\n}\n.font-btn-container .formal-btn {\n  font-family: 'Lora', apple color emoji, segoe ui emoji, noto color emoji, android emoji;\n  font-weight: 500;\n}\n.font-btn-container .playful-btn {\n  font-family: 'Pattaya', apple color emoji, segoe ui emoji, noto color emoji, android emoji;\n}\n.font-btn-container .strong-btn {\n  font-weight: 600;\n  font-family: 'Oswald', apple color emoji, segoe ui emoji, noto color emoji, android emoji, sans-serif;\n}\n.font-btn-container .personal-btn {\n  font-family: 'Gochi Hand', apple color emoji, segoe ui emoji, noto color emoji, android emoji;\n}\n.save-ecard-btn:focus {\n  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n}\n.select-ecard {\n  border-radius: 6px;\n  max-width: 100%;\n  max-height: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n}\n.select-ecard-upload {\n  height: 100%;\n  min-width: 100%;\n  border-radius: 6px;\n  border: 1px dashed gray;\n  padding: 24px;\n  display: flex;\n}\n.ecard-preview {\n  max-width: 100%;\n}\n.primary-background:disabled {\n  background: #f5f5f5 !important;\n}\n.back-btn:focus {\n  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n}\n.bottom-btn-container {\n  text-align: left;\n  max-width: 575px;\n  margin-top: -24px;\n}\n.bottom-btn-container .more-container {\n  margin-right: 6px;\n}\n.bottom-btn-container .more-picker {\n  padding: 6px;\n  margin-right: 6px;\n}\n.bottom-btn-container .more-picker:focus {\n  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n}\n.bottom-btn-container .image-upload {\n  padding: 6px;\n}\n.bottom-btn-container .image-upload svg {\n  height: 18px;\n  width: 18px;\n}\n.bottom-btn-container .image-upload:focus {\n  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n}\n.ecard-drawer {\n  opacity: 0;\n  max-width: 575px;\n  width: 100%;\n  margin-right: auto;\n  height: calc(575px - 61px);\n  bottom: -575px;\n  position: absolute;\n  background-color: white;\n  transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1);\n  overflow: auto;\n  visibility: hidden;\n}\n.ecard-drawer.open {\n  opacity: 1;\n  bottom: -14px;\n  transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1);\n  z-index: 15;\n  min-height: auto;\n  visibility: visible;\n}\n.ecard-drawer .title-row {\n  margin-left: 12px;\n  margin-right: 12px;\n  padding-top: 9px;\n  margin-bottom: 8px;\n}\n.ecard-drawer .ecard-list {\n  padding-left: 12px;\n  padding-right: 12px;\n  justify-content: left;\n  overflow: auto;\n  margin-left: 6px;\n  padding-bottom: 55px;\n  width: 100%;\n}\n.upload-drawer {\n  opacity: 0;\n  max-width: 575px;\n  width: 100%;\n  margin-right: auto;\n  height: calc(575px - 65px);\n  bottom: -700px;\n  position: absolute;\n  background-color: white;\n  padding: 16px;\n  z-index: 16;\n  transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1);\n  visibility: hidden;\n}\n.upload-drawer.hidden {\n  display: none;\n}\n.upload-drawer.open {\n  opacity: 1;\n  bottom: -14px;\n  transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1);\n  z-index: 15;\n  min-height: auto;\n  visibility: visible;\n  display: block;\n}\n.upload-content {\n  height: 435px;\n  border-radius: 16px;\n  border: 1px #dfdfdf dashed;\n  background-color: #f5f5f5;\n  width: 100%;\n}\n.upload-icon {\n  width: 100%;\n  height: 100%;\n  color: #3f8cff;\n}\n.image-icon {\n  width: 18px;\n  height: 18px;\n}\n.upload-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  justify-content: center;\n}\n.upload-container .upload-icon-container {\n  width: 90px;\n  height: 90px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.upload-container .upload-icon {\n  width: 100%;\n  height: 100%;\n}\n.upload-container .upload-text-container {\n  width: 200px;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n}\n.upload-container .upload-text-container .fake-link {\n  text-decoration: underline;\n  color: #3f8cff;\n  cursor: pointer;\n}\n.upload-container .upload-text-container .parameter-text {\n  font-size: 10px;\n  color: #555555;\n}\n.ant-popover-arrow {\n  display: none;\n}\n.text-tools-container {\n  display: flex;\n  justify-content: space-evenly;\n  width: 100%;\n  padding-left: 12px;\n}\n.background-toggle-btn {\n  padding: 4px;\n  display: flex;\n  font-size: 18px;\n}\n.background-toggle-btn:focus {\n  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n}\n.background-toggle-btn.btn-selected {\n  background-color: #ccc;\n}\n.foreground-toggle-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  line-height: 40px;\n}\n.switch-container {\n  display: flex;\n  align-items: center;\n}\n.ecard-message-container {\n  position: absolute;\n  width: 100%;\n  top: 0;\n  max-height: 455px;\n  height: 100%;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  justify-content: center;\n  align-items: center;\n  left: 0;\n}\n.ecard-message-container .ecard-text {\n  border: none;\n  background-color: transparent;\n  text-align: center;\n  font-size: 26px;\n  min-width: 50%;\n  max-width: 75%;\n  resize: none;\n  border-radius: 8px;\n  padding: 12px;\n  font-family: 'Poppins', apple color emoji, segoe ui emoji, noto color emoji, android emoji, sans-serif;\n  font-weight: 600;\n}\n.ecard-actions {\n  bottom: 32px;\n  position: absolute;\n  left: 14px;\n  width: calc(100% - 14px);\n}\n.ecard-actions .edit-text-btn {\n  padding: 6px;\n  right: 12px;\n}\n.ecard-actions .edit-text-btn:focus {\n  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n}\n.ecard-actions .edit-text-btn svg {\n  width: 100%;\n  height: 100%;\n}\n.ecard-actions .edit-text-complete {\n  right: 0;\n}\n.render-image {\n  width: 100% !important;\n  max-height: 455px;\n  margin-left: auto;\n  margin-right: auto;\n  overflow: hidden;\n}\n.render-image img {\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n  object-fit: cover;\n  object-position: 50% 50%;\n}\n.ant-btn.large-circle {\n  height: 40px;\n  width: 40px;\n  border-radius: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.text-right {\n  text-align: right;\n}\n.ecard-title-text {\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ecard-title-text .bold-header {\n  margin-bottom: 0;\n}\n.color-picker-btn .ant-popover.picker-popover,\n.color-picker-btn .ant-popover.color-picker-popover {\n  width: auto;\n}\n.color-picker-btn .ant-popover.picker-popover .ant-popover-inner-content,\n.color-picker-btn .ant-popover.color-picker-popover .ant-popover-inner-content {\n  background-color: #eee;\n}\n.color-picker-btn .ant-popover.color-picker-popover .ant-popover-inner {\n  margin-left: 0;\n  margin-bottom: 0;\n  border-radius: 12px;\n}\n.color-picker-btn .ant-popover.color-picker-popover .ant-popover-inner-content {\n  padding: 20px;\n  border-radius: 12px;\n}\n.color-picker-btn:focus {\n  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n}\n.title-row {\n  margin-bottom: 12px;\n}\n.ecard-image-preview {\n  margin: 6px;\n  max-height: 75px;\n}\n.uppercase {\n  text-transform: uppercase;\n}\n.ant-avatar.behavior-image {\n  margin-right: 12px;\n}\n.circle-picker {\n  background-color: #eee;\n}\n.emoji-container {\n  width: 280px;\n  height: 320px;\n}\n.bold-header {\n  font-weight: 700;\n}\n.required {\n  width: 8px;\n  height: 8px;\n  background-color: red;\n  border-radius: 50%;\n  display: block;\n  z-index: 4;\n  right: 4px;\n  position: absolute;\n}\n.ant-popover aside.emoji-picker-react {\n  padding: 8px;\n  box-shadow: none;\n}\n.ant-popover aside.emoji-picker-react .emoji-categories {\n  bottom: 4px;\n  left: 0;\n  position: absolute;\n  width: 100%;\n  background: #fff;\n  border-radius: 30px;\n  box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);\n  z-index: 101;\n}\n.ant-popover aside.emoji-picker-react .content-wrapper {\n  bottom: 40px;\n}\n.ant-popover aside.emoji-picker-react .content-wrapper:before {\n  content: '';\n}\n.ant-popover aside.emoji-picker-react .content-wrapper .emoji-group:before {\n  text-transform: capitalize;\n  font-size: 12px;\n}\n.ant-popover aside.emoji-picker-react .emoji-scroll-wrapper {\n  top: 40px;\n  padding-bottom: 40px;\n}\n.ant-popover aside.emoji-picker-react .skin-tones-list {\n  margin-top: 14px;\n}\n.ant-popover aside.emoji-picker-react input.emoji-search {\n  margin-top: 12px;\n  border-radius: 8px;\n  background-color: #f5f5f5;\n  border: none;\n}\n.delete-modal .title-container {\n  display: flex;\n}\n.delete-modal .title-container .icon-flex {\n  flex: 2;\n}\n.delete-modal .title-container .title-text {\n  flex: 8;\n  font-weight: bold;\n}\n.delete-modal .title-container .icon-circle {\n  background-color: #de1c1b;\n  width: 56px;\n  height: 56px;\n  border-radius: 30px;\n  padding: 16px;\n}\n.delete-modal .ant-modal-content {\n  height: auto;\n}\n.delete-modal .ant-modal-content .ant-modal-body {\n  padding: 12px;\n}\n.delete-modal .ant-btn-dangerous.ant-btn-primary {\n  background: #de1c1b;\n  border-color: #de1c1b;\n}\n.delete-modal .ant-btn-dangerous.ant-btn-primary:hover,\n.delete-modal .ant-btn-dangerous.ant-btn-primary:active,\n.delete-modal .ant-btn-dangerous.ant-btn-primary:focus {\n  background: #de1c1b;\n  border-color: #de1c1b;\n}\n.delete-modal .ant-btn:focus {\n  -webkit-box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #1f75cb;\n}\n.delete-modal .delete-content {\n  margin-left: 71px;\n  margin-top: -24px;\n}\n@media only screen and (max-device-width: 420px) {\n  .select-ecard-upload {\n    padding: 18px;\n  }\n  .font-btn-container button {\n    font-size: 9px;\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n  .edit-text-complete {\n    margin-left: 12px;\n  }\n  .edit-text-btn {\n    right: 30px;\n  }\n  .text-tools-container {\n    margin-left: 16px;\n  }\n  .text-tools-container .double-btn-container {\n    margin-right: 12px;\n  }\n  .text-tools-container button {\n    z-index: 25;\n  }\n  .ecard-image-preview {\n    min-width: 75px;\n    min-height: 75px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
